module.exports = __webpack_public_path__ + "img/store-3-fill.378e14fb.svg";